module.exports = __webpack_public_path__ + "img/contact.34a74c63.svg";